export default __webpack_public_path__ + "static/media/payment-cards.38874430.jpg";